'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */

import React, { type MouseEventHandler, useState } from 'react'
import { useRouter } from 'next/navigation'
import dynamic from 'next/dynamic'
import { type IMenuItem } from '@components/Ackodrive/header/globalHeader'
import { ACKODRIVE_DOMAIN } from '@components/Ackodrive/common/constants'
import { ActiveLine, MenuOption, MenuOptionWrapper, Title } from './styles'

const SubmenuDropdown = dynamic(() => import('../submenuDropdown'))

export interface ISubMenuOptionProps {
  menuItem: IMenuItem
  menuFontSize: string
  menuFontWeight: string
  menuLineHeight: string
}

export const SubMenuOption = ({ menuItem, menuFontSize, menuFontWeight, menuLineHeight }: ISubMenuOptionProps) => {
  const router = useRouter()
  const [showSubMenuDropdown, setShowSubMenuDropdown] = useState<boolean>(false)

  const handleHoverMenuOption: MouseEventHandler = event => {
    setShowSubMenuDropdown(event?.type === 'mouseenter')
  }

  const handleClickMenuOption = (event: React.MouseEvent<HTMLAnchorElement>, url: string | null) => {
    event.preventDefault()
    url && router.push(url)
  }

  return (
    <MenuOptionWrapper
      key={menuItem?.title}
      onMouseEnter={event => {
        handleHoverMenuOption(event)
      }}
      onMouseLeave={event => {
        handleHoverMenuOption(event)
      }}>
      <MenuOption fontSize={menuFontSize} fontWeight={menuFontWeight} lineHeight={menuLineHeight}>
        <Title
          onClick={e => {
            handleClickMenuOption(e, menuItem?.url)
          }}
          href={`${ACKODRIVE_DOMAIN}${menuItem?.url?.substr(1)}`}>
          <ActiveLine isActive={menuItem?.isActive}>{menuItem?.title}</ActiveLine>
        </Title>
      </MenuOption>
      {showSubMenuDropdown && menuItem?.submenu && <SubmenuDropdown submenus={menuItem?.submenu} />}
    </MenuOptionWrapper>
  )
}
